module.exports = __webpack_public_path__ + "static/media/optionView.e22b3ce4.svg";